import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {snackbarStyles} from '../snackbar'
import {createSnackbarQueue, SnackbarQueue as RmwcSnackbarQueue} from '@rmwc/snackbar'
import '@rmwc/snackbar/styles'

const StyledRmwcSnackbarQueue = styled(RmwcSnackbarQueue)`
  ${snackbarStyles}
`

const SnackbarQueue = (props) => <StyledRmwcSnackbarQueue {...props} />

SnackbarQueue.propTypes = {
  messages: PropTypes.object,
  dismissIcon: PropTypes.bool,
  dismissesOnAction: PropTypes.bool,
  leading: PropTypes.bool,
  stacked: PropTypes.bool,
  timeout: PropTypes.number
}

SnackbarQueue.defaultProps = {
  dismissesOnAction: true,
  leading: true,
  timeout: 4000
}

export {SnackbarQueue}
export {createSnackbarQueue}
